/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioPisosCV from './controladorVista/formularioPisosCV';
import TablaPisosCV from './controladorVista/tablaPisosCV';
import { estadoIncial, reductor } from './reductorPisos';

const Pisos: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaPisosCV />
        <FormularioPisosCV />
    </ProveedorEstado>
);

export default Pisos;
